const UserDefinedTypeName = {
  print: ({ node }) => node.namePath
};

module.exports = UserDefinedTypeName;
